import { MenuPermission, PermissionType, User, UserSystemAttributes } from '../../domain/rbac/RbacDomains';
import { AccessBase } from '../../domain/access/BaseAccess';

export type UserActions = 'SET_USER' | 'SET_PERMISSIONS' | 'SET_ACCESS' | 'SET_ATTRIBUTE';

export const setUser = (user: User | null) => ({ type: 'SET_USER', payload: user });
export const setPermissions = (permissions: MenuPermission[]) => ({ type: 'SET_PERMISSIONS', payload: permissions });
export const setAttribute = (attribute: UserSystemAttributes) => ({ type: 'SET_ATTRIBUTE', payload: attribute });
export const setAccess = (
  base:
    | {
        component: AccessBase | null;
        role: PermissionType | null;
      }
    | undefined,
) => ({ type: 'SET_ACCESS', payload: base });
